import React, { useCallback, useState } from 'react'
import ContactBimmatch from '../contact-bimmatch'


const UnlockPremimumButton = ({ name, src, onClick, href }) => {

    const [isModalVisible, setIsModalVisible] = useState(false)

    const onClickButton = useCallback(() => {
        if (href) {
            window.open(href, "_blank", "noopener,noreferrer")
            onClick && onClick()
            return
        }
        setIsModalVisible(true)
        // will be used in case UnlockPremimumButton is used inside popover content
        // then this modal will open outside
        onClick && onClick()
    }, [onClick, href])

    return ( 
        <>
            <div className='unlock-premium-button' onClick={onClickButton}>
                <img src={src || "/images/icon/lock-open.svg"} alt="button-icon"/>
                <span>{name || "Unlock features and increase efficiency"}</span>
            </div>
            {(isModalVisible && !href) && <ContactBimmatch visible={isModalVisible} onClose={() => setIsModalVisible(false)}/>}
        </>
        

     );
}
 
export default UnlockPremimumButton;